import { ThemeOverride } from '@abstractTypes/theme'
import { fonts } from '@theme/index'

export const solTheme: ThemeOverride = {
  colors: {
    primaryDark: '#000000',
    primaryDarkPressed: '#4C4C4C',
    primaryLight: '#FFFFFF',
    primaryLightPressed: '#FBFBFB',
    inactive: '#C1C1C2',
    outline: '#8E8F93',
    background: '#EAEAEB',
    highlight01: '#59646C',
    highlight01Pressed: '#9BA2A7',
    highlight02: '#DDD19B',
    highlight02Pressed: '#EEE8CD',
    highlight03: '#59646C',
    highlight04: '#59646C',
    functional01: '#E8583F',
    functional02: '#5DB363',
    functional03: '#FFBC57',
  },
  fonts: {
    ...fonts,
    heading0: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 85,
        tablet: 68,
        tabletMini: 60,
      },
      lineHeight: {
        tower: 109,
        tablet: 86,
        tabletMini: 67,
      },
    },
    heading1: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 60,
        tablet: 56,
        tabletMini: 48,
      },
      lineHeight: {
        tower: 68,
        tablet: 62,
        tabletMini: 60,
      },
    },
    heading2: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 40,
        tablet: 40,
        tabletMini: 34,
      },
      lineHeight: {
        tower: 48,
        tablet: 48,
        tabletMini: 46,
      },
    },
    heading3: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 34,
        tablet: 34,
        tabletMini: 28,
      },
      lineHeight: {
        tower: 44,
        tablet: 44,
        tabletMini: 36,
      },
    },
    heading4: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
        bold: 700,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 36,
        tablet: 36,
        tabletMini: 30,
      },
    },
    heading5: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
        bold: 700,
      },
      fontSize: {
        tower: 20,
        tablet: 20,
        tabletMini: 18,
      },
      lineHeight: {
        tower: 26,
        tablet: 26,
        tabletMini: 28,
      },
    },
    body: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
        bold: 700,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    label: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 14,
        tablet: 14,
        tabletMini: 12,
      },
      lineHeight: {
        tower: 24,
        tablet: 24,
        tabletMini: 18,
      },
    },
    cta: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 500,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    link: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 30,
        tabletMini: 26,
      },
    },
    caption: {
      fontFamily: 'Touvlo',
      weight: {
        regular: 500,
      },
      fontSize: {
        tower: 13,
        tablet: 13,
        tabletMini: 11,
      },
      lineHeight: {
        tower: 16,
        tablet: 16,
        tabletMini: 14,
      },
    },
  },
  components: {
    button: {
      style: 'rounded',
      uppercase: true,
    },
    rangeSlider: {
      background: '#C1C1C2',
      foreground: '#DDD19B',
      thumb: '#FFFFFF',
      thumbBorder: '#313235',
    },
  },
}
